import { render } from "./PromotionalBar.vue?vue&type=template&id=7e2916d6&scoped=true"
import script from "./PromotionalBar.vue?vue&type=script&lang=js"
export * from "./PromotionalBar.vue?vue&type=script&lang=js"

import "./PromotionalBar.vue?vue&type=style&index=0&id=7e2916d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e2916d6"]])

export default __exports__